import i18n from '../../utils/i18n'

export const PropertyIdentifierBodyTemplate = (propertyIdentifier: any) => {
  if (!propertyIdentifier) return null

  return (
    <>
      {i18n.t(
        `masterDataManagement.packagingData.table.columns.propertyIdentifier.options.${propertyIdentifier}`,
      )}
    </>
  )
}
